<template>
  <div class="team-member">
    <img :src="`/images/team/${encodeURIComponent(name)}.jpg`" :alt="member.realName">
    <span class="real-name">
      {{ member.realName }}
    </span>
    <span class="separator"></span>
    <div class="roles">
      <span v-for="(role, index) in member.roles" :key="index">
        {{ role }}
      </span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TeamMember',

    props: [
      'member',
      'name',
    ],
  };
</script>

<style lang="less" scoped>
  @import (reference) '../shared.less';

  .team-member {
    display: flex;
    flex-direction: column;
    width: 30vh;
    align-items: center;
    justify-content: space-around;
    text-align: center;
    margin-bottom: 12vh;

    @media @vertical {
      width: 30vw;
      margin-bottom: unset;
      margin-top: 5vw;
    }

    @media @mobile {
      width: 45vh;
      margin-bottom: unset;
    }

    @media @mobile-vertical {
      width: 65vw;
    }

    &+& {
      margin-left: 5vh;

      @media @vertical {
        margin-left: unset;
      }
    }

    &:nth-child(even) {
      @media @vertical {
        margin-left: 6vw;
      }

      @media @mobile-vertical {
        margin-left: unset;
      }
    }

    &:nth-child(-n+2) {
      @media @vertical {
        margin-top: 0;
      }

      @media @mobile-vertical {
        margin-top: 5vw;
      }
    }
  }

  img {
    width: 30vh;
    height: 30vh;
    border-radius: 50%;

    @media @vertical {
      width: 30vw;
      height: 30vw;
    }

    @media @mobile {
      width: 45vh;
      height: 45vh;
    }

    @media @mobile-vertical {
      width: 65vw;
      height: 65vw;
    }
  }

  .real-name {
    font-family: @font-sets[header];
    font-size: 3vh;
    flex-basis: 8vh;
    display: flex;
    align-items: center;

    @media @vertical {
      font-size: 3vw;
      flex-basis: 8vw;
    }

    @media @mobile {
      font-size: 5vh;
      flex-basis: 16vh;
    }

    @media @mobile-vertical {
      font-size: @font-sizes-mv[normal] * 1.5;
      flex-basis: @font-sizes-mv[normal] * 4;
    }
  }

  .separator {
    width: 50%;
    height: 0.2vh;
    background-color: @colors[soft];

    @media @vertical {
      height: 0.2vw;
    }

    @media @mobile {
      display: none;
    }
  }

  .roles {
    color: @colors[soft];
    flex-basis: 8vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media @vertical {
      flex-basis: 8vw;
    }

    @media @mobile {
      display: none;
    }
  }
</style>
